// Crediting transactions have a positive value; debiting transactions have a negative value
export enum ETransactionType {
  paypalWithdraw = -10,
  cryptoWithdraw = -9,
  matchStake = -8,
  subscriptionBurn = -7,
  partnerBurn = -6,
  welcomeCancel = -5,
  promoCancel = -4,
  manualRemove = -3,
  acquiringRefund = -2,
  taskGeneration = -1,
  taskGenerationFail = 1,
  acquiring = 2,
  manualAdd = 3,
  promo = 4,
  welcome = 5,
  partner = 6,
  subscription = 7,
  dailyReward = 8,
  matchPayout = 9,
  matchRefund = 10,
  cryptoWithdrawRefund = 11,
  paypalWithdrawRefund = 12,
}

export enum ETaskTransactionReason {
  created = 'created',
  failed = 'failed',
}

export enum ETopUpTransactionReason {
  purchased = 'coins purchased',
  subscriptionEnd = 'subscription ended',
  subscription = 'subscription purchased',
  trialCoins = 'trial coins',
  partnerBonus = 'partner bonus',
  promo = 'promo code activated',
  firstDepositBonus = 'first deposit bonus',
  dailyReward = 'daily reward',
}

export enum EMatchTransactionReason {
  stake = 'match stake',
  payout = 'match payout',
  refund = 'match refund',
}
